package com.climat.library.domain.toolchain

import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@OptIn(ExperimentalJsExport::class)
@JsExport
class Alias(
    val name: String,
)
